export const equalString = (str1?: string, str2?: string): boolean => {
    if (!str1 || !str2) return false

    return str1?.toLowerCase() === str2?.toLowerCase()
}

export const isEmpty = (text?: string): boolean => {
    if (!text) return true
    else return text?.length === 0
}

export const isNotEmpty = (text?: string): boolean => {
    return !isEmpty(text)
}


